import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LoadingService } from '@common/loading/loading.service';
import { SharedService } from '@services/api/shared.service';
import { MessageService } from '@services/util/message.service';

@Component({
  selector: 're-multiSelect',
  templateUrl: './re-multi-select.component.html',
  styleUrls: ['./re-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReMultipleSelectComponent),
      multi: true,
    },
  ],
})
export class ReMultipleSelectComponent implements ControlValueAccessor, OnInit {
  @Input() truncate: number = 30;
  @Input() isTruncate: boolean = true;
  @Input() isEmail: boolean = false;
  @Input() style: any = {
    width: '100%',
    minWidth: '180px',
  };
  @Input() required_class: any;

  @Output() onUpdate = new EventEmitter<any>();
  @Output() createNew = new EventEmitter<any>();
  @Output() editRecord = new EventEmitter<any>();

  selected = [];
  isAllSelected: boolean = false;
  isHide: boolean = false;
  isHide1: boolean = true;
  filterStr: any = '';
  private _selectedOptions: any[] = [];
  options_list: any[];
  isActiveDeative: boolean = true;
  @Input() isCreateNew: boolean = false;
  @Input() isFullObject: boolean = false;
  @Input() deactiveUser: boolean = false;
  @Input() deactiveProject: boolean = false;
  @Input() options: any[];
  @Input() optionLabel: any;
  @Input() optionValue: any;
  @Input() not_sorted: boolean = false;
  @Input() isMultiple: boolean = false;
  @Input() height: number = null;
  @Input() borderRadius: number = null;
  @Input() placeholder: any = 'Search Response';
  @Input()
  get selectedOptions() {
    return this._selectedOptions;
  }
  set selectedOptions(val: any[]) {
    this._selectedOptions = val;
  }

  @Output() selectedOptionsChange = new EventEmitter<any[]>();
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    this._selectedOptions = value || [];
    this.selected = [];
    this.options_list = this.filterByProjectStatus(this.options);

    if (this.options_list?.length && this._selectedOptions?.length) {
      this.selectedOptions?.length === this.options?.length ? (this.isAllSelected = true) : (this.isAllSelected = false);
      this.options_list = [...this.options_list, ...this.selected];
      this.selected = [];
      this.filterAndSelectItems(this.options_list, this._selectedOptions, this.optionValue, this.selected);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  constructor(
    private messageService: MessageService,
    private loading: LoadingService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options'] && !this.isHide) {
      let opt: any[] = [];
      if (this.optionValue === undefined || this.optionValue === null || this.optionValue === 'abc_xyz') {
        this.options.forEach(x => opt.push({ abc_xyz: x }));
        this.optionValue = 'abc_xyz';
        this.optionLabel = 'abc_xyz';
        this.options_list = [...opt];
        this.isFullObject = false;
      } else {
        this.options_list = this.filterByProjectStatus(this.options);
      }
      this.selected = [];
      this.filterAndSelectItems(this.options_list, this.selectedOptions, this.optionValue, this.selected);
    }
    if (changes['selectedOptions'] && !changes['selectedOptions'].firstChange && !this.isHide) {
      this.options_list = [...this.options_list, ...this.selected];
      this.selected = [];
      this.filterAndSelectItems(this.options_list, this.selectedOptions, this.optionValue, this.selected);
    }

    // Ensure reset works even when reference hasn't changed
    if ('selectedOptions' in changes || this._selectedOptions?.length === 0) {
      const newVal = this.selectedOptions;
      if (!newVal?.length) {
        this.selected = [];
        this.options_list = !this.isActiveDeative && !this.deactiveProject ? this.options_list : this.filterByProjectStatus(this.options);
      }
    }

    if (changes['options']?.currentValue?.length && this._selectedOptions?.length) {
      this.selectedOptions?.length == this.options?.length ? (this.isAllSelected = true) : (this.isAllSelected = false);
    }
    this.selectedOptions?.length == this.options?.length ? (this.isAllSelected = true) : (this.isAllSelected = false);
  }

  ngOnInit() {
    this.messageService.getMessage().subscribe({
      next: f => {
        if (f?.isClearItems) {
          this.isAllSelected = false;
          this.selected = [];
          this.cdr.markForCheck();
        }
      },
    });
  }

  filterAndSelectItems(array, selectedOption, optionValue, selected) {
    if (!selectedOption) {
      return;
    }
    for (let i = array.length - 1; i >= 0; i--) {
      if (selectedOption.includes(array[i][optionValue])) {
        selected.push(array[i]); // Add to selected
        array.splice(i, 1); // Remove from original array
      }
    }
  }

  getStyle = (style: any) => {
    let newStyle: any = { ...style };
    return newStyle;
  };

  addRemove = (item: any) => {
    if (this.isMultiple) {
      this.selected = [];
    }
    this.isHide1 = false;
    let isItem = this.selected.find((x: any) => x[this.optionValue] === item[this.optionValue]);
    if (isItem === undefined) {
      // Add item to selected list if not already present
      if (!this.selected.some(selectedItem => selectedItem[this.optionValue] === item[this.optionValue])) {
        this.selected.push(item);
        // Explicitly remove from options_list
        const index = this.options_list.findIndex(selectedItem => selectedItem[this.optionValue] === item[this.optionValue]);
        if (index !== -1) {
          this.options_list.splice(index, 1); // Removes item at found index
        }
      }
      this.updateEvent();
    } else {
      // Remove item from selected list
      const index = this.selected.findIndex(selectedItem => selectedItem[this.optionValue] === item[this.optionValue]);
      if (index !== -1) {
        this.selected.splice(index, 1); // Explicitly remove item
      }
      if (this.isAllSelected) {
        this.isAllSelected = false;
      }

      // Add item back to options_list and sort it
      this.options_list.push(item);
      this.updateEvent();
    }
    setTimeout(() => {
      this.isHide1 = true;
    }, 10);

    let option_list = this.options;

    this.selected?.length == option_list?.length + this.selected?.length ? (this.isAllSelected = true) : (this.isAllSelected = false);
  };

  updateEvent() {
    this.selected.sort((a, b) => a[this.optionLabel].localeCompare(b[this.optionLabel])); // Sorting in ascending order

    let selectedOptions = [];
    this.selected.forEach((x: any) => selectedOptions.push(x[this.optionValue]));
    this.selectedOptions = this.isFullObject ? this.selected : selectedOptions;
    this.selectedOptionsChange.emit(this.selectedOptions); // Emit to parent
    this.onChange(this.selectedOptions);
    this.onUpdate.emit(this.selectedOptions);
  }

  ocClickOut = (eve: any) => {
    if (eve?.bol === false && this.isHide1) {
      this.isHide = false;
      this.cdr.markForCheck();
    }
  };

  /** True briefly right after the panel opens, so the opening click can't toggle Select All. */
  private justOpened = false;

  showDropdown = () => {
    if (this.isHide) {
      this.isHide = false;
      return;
    }
    // Defer open so the same click that opened the panel cannot hit the
    // "Select All" checkbox (input) rendered directly under the cursor.
    setTimeout(() => {
      this.isHide = true;
      // Guard window: the deferred open renders the Select-All input under the cursor, so a
      // stray click/mouseup from the same gesture could select everything. Ignore Select All
      // until this clears.
      this.justOpened = true;
      setTimeout(() => {
        this.justOpened = false;
      }, 250);
      // markForCheck: the deferred toggle runs in a later tick, so an OnPush
      // host (e.g. Lead Overview) would otherwise skip rendering the panel.
      this.cdr.markForCheck();
    }, 0);
  };

  onLabelClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // Only run when clicking EXACT LABEL area
    if (target.tagName.toLowerCase() === 'input') {
      if (this.justOpened) {
        // This is the click that just opened the panel — don't let it select all.
        event.preventDefault();
        return;
      }
      this.selectAll();
    } else {
      event.stopPropagation();
    }
  }

  selectAll = () => {
    this.isAllSelected = !this.isAllSelected;
    if (this.isAllSelected) {
      this.selected = [...this.options_list, ...this.selected];
      this.options_list = [];
    } else {
      this.options_list = [...this.options_list, ...this.selected];
      this.selected = [];
    }

    let selectedOptions = [];
    this.selected.forEach((x: any) => selectedOptions.push(x[this.optionValue]));
    this.selectedOptions = this.isFullObject ? this.selected : selectedOptions;
    this.selectedOptionsChange.emit(this.selectedOptions); // Emit to parent
    this.onChange(this.selectedOptions); // <-- for reactive form support
    this.onUpdate.emit(this.selectedOptions);
  };

  createNewItem = () => {
    this.isHide = false;
    this.createNew.emit(true);
  };

  spliceItem(i) {
    this.options_list = [...this.options_list, ...[this.selected[i]]];
    this.selected.splice(i, 1);
    let selectedOptions = [];
    this.selected.forEach((x: any) => selectedOptions.push(x[this.optionValue]));
    this.selectedOptions = this.isFullObject ? this.selected : selectedOptions;
    this.selectedOptionsChange.emit(this.selectedOptions); // Emit to parent
    this.onChange(this.selectedOptions); // <-- for reactive form support
    this.onUpdate.emit(this.selectedOptions);

    if (this.isAllSelected) {
      this.isAllSelected = false;
    }
  }

  openRecord(record) {
    this.editRecord.emit(record);
  }

  trackByOption(index: number, item: any): any {
    return item?.[this.optionValue] || item?.[this.optionLabel] || index;
  }

  get sortedOptions() {
    if (!this.options_list || !this.optionLabel) return [];

    return [...this.options_list].sort((a, b) => {
      const valA = Number(a[this.optionLabel]);
      const valB = Number(b[this.optionLabel]);

      // Handle NaN values by pushing them to the end
      if (isNaN(valA)) return 1;
      if (isNaN(valB)) return -1;

      return valA - valB; // Numeric sort
    });
  }

  get sortedSelected() {
    if (!this.selected || !this.optionLabel) return [];

    return [...this.selected].sort((a, b) => {
      const valA = Number(a[this.optionLabel]);
      const valB = Number(b[this.optionLabel]);

      // Handle NaN values by pushing them to the end
      if (isNaN(valA)) return 1;
      if (isNaN(valB)) return -1;

      return valA - valB; // Numeric sort
    });
  }

  /**
   * `Project_Status` arrives as 'Active' / 'Inactive' / 'In Active' depending on where the project
   * was created, so match on a whitespace-stripped form. A project with no status counts as Active —
   * dropping it would hide it from both sides of the toggle instead of just one.
   */
  private isProjectActive(project: any): boolean {
    return (project?.Project_Status || '').replace(/\s+/g, '').toLowerCase() !== 'inactive';
  }

  /** Only the project toggle splits `options` by status; every other select uses the list as given. */
  private filterByProjectStatus(list: any[]): any[] {
    const options = [...(list || [])];
    return this.deactiveProject ? options.filter(x => this.isProjectActive(x) === this.isActiveDeative) : options;
  }

  getActiveDeactiveOptions() {
    if (this.deactiveProject) {
      // Projects come down in one call, so the toggle re-splits the existing list instead of refetching.
      this.options_list = this.filterByProjectStatus(this.options);
      // Selected items render from `selected`, so strip them here to avoid a duplicate row.
      this.filterAndSelectItems(this.options_list, this.selectedOptions, this.optionValue, []);
      this.cdr.markForCheck();
      return;
    }
    if (this.isActiveDeative == true) {
      this.options_list = this.options;
    } else {
      this.loading.show();
      this.sharedService.getDeactiveStaffList().subscribe({
        next: (response: any) => {
          this.loading.hide();
          this.options_list = response?.data || [];
          this.cdr.markForCheck();
        },
      });
    }
  }
}
